import React from "react";
import { Link } from "react-router-dom";

const ListCard = ({
  totalOffers,
  OfferAmount,
  totalInvoices,
  totalProformaInvoices,
  ProformaInvoiceAmount,
  InvoiceAmount,
  totalUnpaidInvoices,
  UnpaidInvoiceAmount,
  products,
}) => {
  return (
    <div className="p-4 sm:p-6 bg-white rounded-lg shadow-lg w-full">
      <h2 className="text-lg sm:text-xl font-semibold mb-4 text-gray-700">
        Financial Summary
      </h2>
      <div className="overflow-x-auto">
        <table className="min-w-full table-auto border-collapse">
          <thead>
            <tr className="bg-gray-100">
              <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">
                Category
              </th>
              <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">
                Total
              </th>
              <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="px-4 py-2 text-sm font-medium text-gray-800">
                Total Offers
              </td>
              <td className="px-4 py-2 text-sm text-gray-600">{totalOffers}</td>
              <td className="px-4 py-2 text-sm text-green-600 font-semibold">
                Rs. {OfferAmount}
              </td>
            </tr>
            <tr className="bg-gray-50">
              <td className="px-4 py-2 text-sm font-medium text-gray-800">
                Total Proforma Invoices
              </td>
              <td className="px-4 py-2 text-sm text-gray-600">
                {totalProformaInvoices}
              </td>
              <td className="px-4 py-2 text-sm text-red-600 font-semibold">
                Rs. {ProformaInvoiceAmount}
              </td>
            </tr>
            <tr>
              <td className="px-4 py-2 text-sm font-medium text-gray-800">
                Total Invoices
              </td>
              <td className="px-4 py-2 text-sm text-gray-600">
                {totalInvoices}
              </td>
              <td className="px-4 py-2 text-sm text-blue-600 font-semibold">
                Rs. {InvoiceAmount}
              </td>
            </tr>
            <tr className="bg-gray-50">
              <td className="px-4 py-2 text-sm font-medium text-gray-800">
                Total Unpaid Invoices
              </td>
              <td className="px-4 py-2 text-sm text-gray-600">
                {totalUnpaidInvoices}
              </td>
              <td className="px-4 py-2 text-sm text-purple-600 font-semibold">
                Rs. {UnpaidInvoiceAmount}
              </td>
            </tr>
            <tr>
              <td className="px-4 py-2 text-sm font-medium text-gray-800">
                Total Products
              </td>
              <td className="px-4 py-2 text-sm text-gray-600">{products}</td>
              <td className="px-4 py-2 text-sm text-blue-600 font-semibold">
                -
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ListCard;
